const getConfigValue = key => {
  if (process.env.NODE_ENV == 'development') return process.env[key];
  return window.deploymentConfig[key];
};

const DEPLOYMENT_URL = getConfigValue('REACT_APP_DEPLOYMENT_URL');
const CLIENT_ID = getConfigValue('REACT_APP_CLIENT_ID');
const AUTHORITY = getConfigValue('REACT_APP_AUTHORITY');
const KNOWN_AUTHORITIES = getConfigValue('REACT_APP_KNOWN_AUTHORITIES');
const LOGIN_SCOPE = getConfigValue('REACT_APP_LOGIN_SCOPE');
const DORIS_SCOPE = getConfigValue('REACT_APP_DORIS_SCOPE');

const STORAGE_ACCOUNT_NAME = getConfigValue('REACT_APP_STORAGE_ACCOUNT_NAME');
const STORAGE_PRINT_CONTAINER = getConfigValue('REACT_APP_STORAGE_PRINT_CONTAINER');
const STORAGE_EMAIL_CONTAINER = getConfigValue('REACT_APP_STORAGE_EMAIL_CONTAINER');

const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    knownAuthorities: KNOWN_AUTHORITIES.split(' '),
    redirectUri: DEPLOYMENT_URL,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  }
};

const getBaseBackendApiUrl = () => `${DEPLOYMENT_URL}/api`;

const loginRequest = {
  scopes: LOGIN_SCOPE.split(' ')
};

const dorisRequest = {
  scopes: DORIS_SCOPE.split(' ')
};


export {
  DEPLOYMENT_URL,
  msalConfig,
  loginRequest,
  dorisRequest,
  getBaseBackendApiUrl,
  STORAGE_ACCOUNT_NAME,
  STORAGE_EMAIL_CONTAINER,
  STORAGE_PRINT_CONTAINER
};
